import { alpha } from "@mui/system";
import { getDiagramCanvasBackground } from "../styles";

// Estilos específicos do canvas e área interativa do diagrama
const styles = (theme) => ({
  // Estrutura base que permite alternar entre canvas embutido e overlay
  canvasShell: {
    width: "100%",
    position: "relative",
  },
  // Overlay ampliado que ocupa viewport sem desmontar React Flow
  canvasShellExpanded: {
    position: "fixed",
    inset: 0,
    zIndex: theme?.zIndex?.modal,
    p: { xs: 1, sm: 1.5 },
    display: "flex",
    flexDirection: "column",
    gap: 1,
    backgroundColor: theme?.palette?.background?.default,
  },
  // Barra de ações do canvas com logo à esquerda e botão de fechar/reduzir à direita
  canvasActionBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 36,
  },
  canvasActionButton: {
    color: theme?.palette?.primary?.main,
  },
  // Agrupa Salvar + Reduzir diagrama do lado direito da barra de ações do canvas ampliado
  canvasActionGroup: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  // Logo reduzida com drop-shadow sutil no modo claro para contraste
  canvasActionLogo: {
    height: 34,
    width: "auto",
    display: "block",
    filter:
      theme?.palette?.mode === "light"
        ? `drop-shadow(0 1px 3px ${alpha(theme?.palette?.common?.black, 0.45)})`
        : "none",
  },
  // Container do canvas com altura fixa necessária para o React Flow
  canvasWrapper: {
    height: 500,
    width: "100%",
    borderRadius: 2,
    overflow: "hidden",
    border: `1px solid ${theme?.palette?.divider}`,
    backgroundColor: getDiagramCanvasBackground(theme),
  },
  // Dimensões do canvas quando overlay ocupa viewport
  canvasWrapperExpanded: {
    height: "calc(100vh - 64px)",
    minHeight: 0,
    flex: 1,
  },
  // Painel de edição de conexão selecionada no canvas
  inspectorBox: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    p: 1.5,
    borderRadius: 2,
    width: { xs: "min(320px, calc(100vw - 32px))", sm: 320 },
    backgroundColor: theme?.palette?.background?.paper,
    border: `1px solid ${theme?.palette?.divider}`,
  },
  inspectorTitle: {
    fontSize: 12,
    fontWeight: 700,
    color: theme?.palette?.text?.primary,
  },
  inspectorDeleteBox: {
    display: "flex",
    justifyContent: "flex-end",
    pt: 0.5,
    borderTop: `1px solid ${theme?.palette?.divider}`,
  },
  // Mesmo padrão do botão "Excluir" do NodeInspector: vermelho + texto, alinhado à esquerda
  // como os demais campos fullWidth do inspetor (em vez do centralizado padrão do Button)
  deleteButton: {
    justifyContent: "flex-start",
  },
  // Rótulo de seleção de cor dentro do menu de contexto
  contextMenuColorLabel: {
    fontSize: 11,
    fontWeight: 700,
    color: theme?.palette?.text?.secondary,
    px: 2,
    pt: 1,
  },
});

export default styles;
